import React from 'react';

import { BaseModalProps } from '../types';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';

export type BasicModalProps = {
  title?: string;
  body?: string;
  btnText?: string;
  onBtnClick?: () => void;
  children?: React.ReactNode;
  onClose?: () => void;
};

const BasicModal = ({
  title,
  body,
  btnText,
  onBtnClick,
  closeModal,
  children,
}: BasicModalProps & Pick<BaseModalProps, 'closeModal'>) => {
  const handleOnBtnClick = () => {
    closeModal();
    if (onBtnClick) {
      onBtnClick();
    }
  };

  return (
    <ModalLayout close={closeModal}>
      <div className="[&_button]:w-full">
        {title && <h1 className="mb-4 text-center text-lg font-bold">{title}</h1>}
        {body && <p className="text-center max-w-xs">{body}</p>}
        {children && <div>{children}</div>}
        {onBtnClick && <Button onClickHandler={handleOnBtnClick} text={btnText ?? ''}></Button>}
      </div>
    </ModalLayout>
  );
};

export default BasicModal;
